import React from 'react'
import classnames from 'classnames'
import { useLocation } from 'react-router-dom'

import Footer from '@krea/common/shared-components/app/footer'

import styles from './Layout.module.scss'
import Header from './../header/index'

const Layout = ({ children, MiddleNavbarComponent, logout, menu, user, applicationSelector }) => {
	const { pathname } = useLocation()
	const isNotLoginPage = pathname !== '/login'
	const isDelegate = pathname === '/delegated-information'
	const isPreliminaryBidForm = pathname === '/direct/preliminary-bid-form'

	return (
		<div className="d-flex flex-column h-100 w-100 overflow-hidden">
			<Header
				MiddleNavbarComponent={MiddleNavbarComponent}
				logout={logout}
				menu={menu}
				applicationSelector={applicationSelector}
			/>
			<main
				className={classnames(
					styles.main,
					{ [styles.login]: !isNotLoginPage || isDelegate || isPreliminaryBidForm },
					'flex-grow-1 flex-shrink-0'
				)}
			>
				{children}
			</main>
			<Footer />
		</div>
	)
}

export default Layout
